// 내부수정: 세금계산서 개별 발행

import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useModal} from "../../../../../hooks";
import {AxiosError} from "axios";
import {issueTaxIndividual} from "../../../../../api/order/DeadlineApi";
import {DeadlineListElementType} from "../interface";

export const useIssueTaxIndividual = ({ closeCallback }: { closeCallback: () => any }) => {
    const { handleModal } = useModal();
    const qc = useQueryClient();
    const { mutate } = useMutation({
        mutationFn: (data: DeadlineListElementType[]) => issueTaxIndividual(data),
        onSuccess: (res) => {
            if (res.data.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: "발행되었습니다.",
                    type: "alert",
                    closeAction: () => {
                        qc.invalidateQueries({ queryKey: ["readShipmentDetail"] });
                        qc.invalidateQueries({ queryKey: ["readDeadlineList"] });
                        closeCallback();
                    },
                });
            } else {
                handleModal({
                    isOpen: true,
                    contents: res.data.msg,
                    type: "alert",
                });
            }
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error.response.data.msg,
                    type: "alert",
                });
            }
        },
    });
    return { mutate };
};